import Vue from 'vue';
import Vuex from 'vuex';
import App from './modules/app';

Vue.use(Vuex);

let modules = {
    App,
};

export default new Vuex.Store({
    modules,
})


// WEBPACK FOOTER //
// ./src/store/index.js